interface Props {
  page: number;            // 0-based
  size: number;
  total: number;
  onPageChange: (page: number) => void;
  onSizeChange: (size: number) => void;
  sizes?: number[];
}

export function PaginationControls({ page, size, total, onPageChange, onSizeChange, sizes = [10, 20, 50] }: Props) {
  if (total === 0) return null;
  const nbPages = Math.max(1, Math.ceil(total / size));
  // Clamp défensif : si `page` dépasse la dernière page (état transitoire après
  // qu'une mutation a réduit `total`), éviter une plage inversée « 61–41 sur 41 ».
  const safePage = Math.min(Math.max(0, page), nbPages - 1);
  const from = safePage * size + 1;
  const to = Math.min(total, (safePage + 1) * size);
  const isFirst = safePage <= 0;
  const isLast = safePage >= nbPages - 1;
  return (
    <nav role="navigation" aria-label="Pagination" className="flex items-center justify-between gap-3 px-4 py-2.5 text-xs text-slate-600 border-t border-slate-200">
      <span aria-current="page">{from} à {to} sur {total}</span>
      <div className="flex items-center gap-2">
        <button
          type="button" data-testid="pagination-prev" aria-label="Page précédente"
          disabled={isFirst} onClick={() => onPageChange(safePage - 1)}
          className="px-2 py-1 rounded border border-slate-200 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-slate-50"
        >◀ Préc.</button>
        <span className="tabular-nums">Page {safePage + 1}/{nbPages}</span>
        <button
          type="button" data-testid="pagination-next" aria-label="Page suivante"
          disabled={isLast} onClick={() => onPageChange(safePage + 1)}
          className="px-2 py-1 rounded border border-slate-200 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-slate-50"
        >Suiv. ▶</button>
        <select
          data-testid="pagination-size" aria-label="Taille de page" value={size}
          onChange={(e) => onSizeChange(Number(e.target.value))}
          className="border border-slate-200 rounded h-7 px-1"
        >
          {sizes.map((s) => <option key={s} value={s}>{s}/page</option>)}
        </select>
      </div>
    </nav>
  );
}
